import { ChangeDetectorRef, Component, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TimeApiService } from 'cbc-shared-lib';
import {
  Sgke351aRequest, Sgke351aResponseInitialhyojiInfo, Sgke352aRequest,
  Sgke352aResponseSearchresultHyojiInfo, Sgke352aResponseSearchresultList,
  Sgke353aRequest, Sgke353aRequestUpdateCndtList, Sgke903aRequest,
  Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo,
  Szza012aRequest
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { Sgke350dResultComponent } from '../../components/sgke350d-result/sgke350d-result.component';
import { UsedSgke351aService } from '../../services/used-sgke351a.service';
import { UsedSgke352aService } from '../../services/used-sgke352a.service';
import { UsedSgke353aService } from '../../services/used-sgke353a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke350d',
  templateUrl: './sgke350d.component.html',
  styleUrl: './sgke350d.component.scss'
})
export class Sgke350dComponent {

  @ViewChild(Sgke350dResultComponent)
  public sgke350dResultComponent!: Sgke350dResultComponent;

  /** 画面ID */
  private static GAMEN_ID = 'SGKE350D';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;

  /** 初期表示情報 */
  initialhyojiInfo: Sgke351aResponseInitialhyojiInfo;
  /** 検索結果リスト */
  searchresultList: Array<Sgke352aResponseSearchresultList> = new Array<Sgke352aResponseSearchresultList>();
  /** 検索結果表示情報 */
  searchresultHyojiInfo: Sgke352aResponseSearchresultHyojiInfo;

  /** 供給再開作業割当検索APIリクエスト */
  requestSgke352a: Sgke352aRequest;
  /** 供給再開作業割当登録APIリクエスト */
  requestSgke353a: Sgke353aRequest;
  /** SGKE352Aリクエストデータフォーム */
  sgke352arequestForm: UntypedFormGroup;

  /** 業務日付 */
  businessDate: Date;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;

  /**
   * コンストラクタ
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UsedSgke351aService} initService
   * @param {UsedSgke352aService} searchService
   * @param {UsedSgke353aService} registrationService
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {UntypedFormBuilder} fb
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke350dComponent
   */
  constructor(
    private companyAreaInfoService: UsedSgke903aService,
    public getDateService: UsedSzza012aService,
    public initService: UsedSgke351aService,
    public searchService: UsedSgke352aService,
    public registrationService: UsedSgke353aService,
    private timeApiService: TimeApiService,
    public responseMsgUtils: ResponseMsgUtils,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
  ) {
  }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  ngOnInit(): void {

    // 登録情報のFormを初期化
    this.sgke352arequestForm = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });

    // 初期表示検索
    this.init();

    // 会社・入金地区取得
    this.companyAreaInfo();

    // 業務日付取得
    this.getBusinessDate();
  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 検索ボタン押下時処理
   * @public
   * @param {boolean} [reSearch=false]
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  public onClickSearch(reSearch: boolean = false): void {

    // searchResult初期化
    this.searchresultList.length = 0;

    // 再検索時はメッセージエリアをクリアしない・リクエストを作らない（初回検索時のリクエストを再利用する）/
    if (!reSearch) {
      this.errorMessageModelArray = new Array<SgAriaMessage>();
      this.cd.detectChanges();
      // リクエスト情報をもつオブジェクトを定義
      this.requestSgke352a = this.sgke352arequestForm.getRawValue() as Sgke352aRequest;
    }

    // SGKE352A呼び出し
    this.searchService.doSgke352a(this.requestSgke352a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.searchresultList) {
          this.searchresultList = response.searchresultList;
          this.searchresultHyojiInfo = response.searchresultHyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      }
    );
  }

  /**
   * クリアボタン押下時処理
   * @public
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  public onClickClear(): void {
    // エラーメッセージクリア
    this.clearErrorMsg();
    this.searchresultList.length = 0;
    this.searchresultHyojiInfo = null;
  }

  /**
   * 登録ボタン押下時処理
   * @public
   * @param {Sgke352aResponseSearchresultList[]} selected
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  public onClickRegist(selected: Sgke352aResponseSearchresultList[]): void {
    // エラーメッセージクリア
    this.clearErrorMsg();

    // 相関チェック
    if (this.checkCorrelation(selected)) {
      // 相関チェックに該当した場合
      if (!window.confirm('拠点リストまたは担当者リストが未設定の行が存在しますが、対象外として処理を実施します。')) {
        return;
      }
    }

    const newSelected: Sgke352aResponseSearchresultList[] = this.filterValidList(selected);

    if (newSelected.length < 1) {
      // 相関チェックNGのリストを除外した結果、リストが1件も存在しない場合、登録APIを実施しない
      // 再検索
      this.onClickSearch(true);
      return;
    }

    // オブジェクト生成関数
    let updateCndtListFunc = function (row: Sgke352aResponseSearchresultList): Sgke353aRequestUpdateCndtList {

      const gasEquipmentinformation = row.gasEquipmentinformation;

      return {
        suppntSpno: row.suppntSpno,
        supplystopresumptionRrkno: row.supplystopresumptionRrkno,
        supplystopresumptionWayCode: row.resumeClsfy.codeValue,
        baseCode: row.base.codeValue,
        workTntshCode: row.workTntsh.codeValue,
        supplystopresumptionPointinfomngUpdatesequencenumber: row.supplystopresumptionPointinfomngUpdatesequencenumber,
        gasEquipmentinformation: {
          suppntSpno: gasEquipmentinformation.suppntSpno,
          sougouDivcd: gasEquipmentinformation.sougouDivcd,
          sougouSupplydestinationNo: gasEquipmentinformation.sougouSupplydestinationNo,
          energyClscode: gasEquipmentinformation.energyClscode,
          meterClsfy: gasEquipmentinformation.meterClsfy,
          meterDiscrm: gasEquipmentinformation.meterDiscrm,
          meterNo: gasEquipmentinformation.meterNo,
          meterAbility: gasEquipmentinformation.meterAbility,
          meterBunruiCode: gasEquipmentinformation.meterBunruiCode,
          metermodel: gasEquipmentinformation.metermodel,
          supplydestinationAddrCode: gasEquipmentinformation.supplydestinationAddrCode,
          supplydestinationAddr: gasEquipmentinformation.supplydestinationAddr,
          supplydestinationBantiGou: gasEquipmentinformation.supplydestinationBantiGou,
          supplydestinationTatemononame: gasEquipmentinformation.supplydestinationTatemononame,
          supplydestinationAim: gasEquipmentinformation.supplydestinationAim,
          gasOpenclosevalveState: gasEquipmentinformation.gasOpenclosevalveState,
          attendanceKahi: gasEquipmentinformation.attendanceKahi,
          autolockUmuFlg: gasEquipmentinformation.autolockUmuFlg,
          autolockPin: gasEquipmentinformation.autolockPin,
          autolockKeyStoragelocation: gasEquipmentinformation.autolockKeyStoragelocation,
          etcKeyInfo: gasEquipmentinformation.etcKeyInfo,
          supplydestinationNaviInfo: gasEquipmentinformation.supplydestinationNaviInfo,
          jikaiKenshinPlndate: gasEquipmentinformation.jikaiKenshinPlndate,
          jijikaiKenshinPlndate: gasEquipmentinformation.jijikaiKenshinPlndate,
          jijijikaiKenshinPlndate: gasEquipmentinformation.jijijikaiKenshinPlndate
        }
      };
    }

    // 登録リクエスト情報をもつオブジェクトを定義
    this.requestSgke353a = {
      requestCommon: null,
      updateCndtList: newSelected.map(updateCndtListFunc)
    };

    // SGKE353A呼び出し
    this.registrationService.doSgke353a(this.requestSgke353a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(

        response => {
          if (response) {
            // メッセージを表示
            this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
            // 再検索
            this.onClickSearch(true);

          }
        },
        error => {
        }
      );
  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @private
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  private companyAreaInfo(): void {
    let requestInfo: Sgke903aRequest = {
      requestCommon: null,
      reqBusinessArea: {
        gamenId: Sgke350dComponent.GAMEN_ID
      }
    };

    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.responseBusinessArea) {
          this.cmpnyAreaList = response?.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response?.responseBusinessArea.initialhyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);

      },
      error => {
      });

  }

  /**
   * 業務日付取得
   * @private
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  private getBusinessDate() {
    // SZZA012Aのリクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null,
    };

    // SZZA012A呼び出し
    this.getDateService
      .doSzza012a(this.requestSzza012a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {
          if (response?.todayDay) {
            this.businessDate = this.timeApiService.convertStringToDate(
              response.todayDay
            );
          }
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        },
        (error) => {
        }
      );
  }


  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  private clearErrorMsg(): void {
    if (this.errorMessageModelArray.length > 0) {
      this.errorMessageModelArray.length = 0;
    }
  }

  /**
   * 初期表示API呼び出し
   * @private
   * @returns {void}
   * @memberof Sgke350dComponent
   */
  private init(): void {

    // Formの内容をリクエストに設定
    let request: Sgke351aRequest = {
      requestCommon: null,
    };

    //SGKE351A_供給再開作業割当初期表示API呼び出し
    this.initService.doSgke351a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response?.initialhyojiInfo) {
            this.initialhyojiInfo = response.initialhyojiInfo;
          }
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        }, error => {
        });
  }

  /**
   * 相関チェック
   * @private
   * @param {Sgke352aResponseSearchresultList[]} selected 
   * @returns {boolean}
   * @memberof Sgke350dComponent
   */
  private checkCorrelation(selected: Sgke352aResponseSearchresultList[]): boolean {
    // 再開種別が一般供給再開または簡易供給再開かつ
    // 拠点リスト、または担当者リストが未設定の場合
    return selected.some(item => {
      return this.checkCorrelationDetail(item);
    });

  }

  /**
   * 登録対象外のリストを除外
   * @private
   * @param {Sgke352aResponseSearchresultList[]} selected 
   * @returns {Sgke352aResponseSearchresultList[]}
   * @memberof Sgke350dComponent
   */
  private filterValidList(selected: Sgke352aResponseSearchresultList[]): Sgke352aResponseSearchresultList[] {
    // 再開種別が一般供給再開または簡易供給再開かつ
    // 拠点リスト、または担当者リストが未設定の場合リストから除外する
    return selected.filter(item => {
      return !this.checkCorrelationDetail(item);;
    });

  }

  /**
   * 相関チェック詳細処理
   * @param {Sgke352aResponseSearchresultList} row 
   * @returns {boolean}
   */
  private checkCorrelationDetail(row: Sgke352aResponseSearchresultList): boolean {
    const isResumeClsfyResultCheck = row.resumeClsfy.codeValue === '11' || row.resumeClsfy.codeValue === '12';
    const isBaseResultCheck = !row.base.codeValue || !row.workTntsh.codeValue;
    return isResumeClsfyResultCheck && isBaseResultCheck;
  }

}
